import React from "react";
import Select from "react-select";
import './selectFilter.css';
import PropTypes from "prop-types";

export class SelectFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newOptions: []
        }
    }

    componentDidMount() {
        this.updateOptions(this.props.options);
    }

    updateOptions(options) {
        let newOptions = [];
        if (this.props.showAll && options) {
            let allOption = {};
            allOption[this.props.valueKey] = 'all';
            newOptions = [allOption, ...options]
        } else {
            newOptions = options;
        }
        this.setState({newOptions: newOptions});
    }

    componentDidUpdate(prevProps) {
        if (prevProps.options !== this.props.options) {
            this.updateOptions(this.props.options);
        }
    }


    render() {
        const {newOptions}=this.state;
        const {options, ...props}=this.props;
        const selectedOption = this.props.value || null;
        return <div className={this.props.type?"select-dropdown-country":"select-dropdown"}>
            <Select {...props}
                value={selectedOption}
                isClearable={props.clearable?props.clearable:false}
                options={newOptions}
        /></div>
    }
}

SelectFilter.propTypes = {
  options: PropTypes.array,
  showAll: PropTypes.bool,
  valueKey: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
  clearable: PropTypes.bool,
  onChange: PropTypes.func,
};